import { apiService } from './api';
import { SageItem, CreateSageItemRequest, UpdateSageItemRequest } from '../types/sageItem';
import { SAGE_COMPANY_ID } from '../constants/sage';

export const sageItemService = {
  getAllLocal: async () => {
    return apiService.get<SageItem[]>('/sage/items/local');
  },

  getAllFromSage: async () => {
    return apiService.get<SageItem[]>('/sage/items', { companyId: SAGE_COMPANY_ID });
  },

  getById: async (id: number) => {
    return apiService.get<SageItem>(`/sage/items/${id}`, { companyId: SAGE_COMPANY_ID });
  },

  syncFromSage: async () => {
    return apiService.post<SageItem[]>(`/sage/items/sync?companyId=${SAGE_COMPANY_ID}`);
  },

  create: async (data: CreateSageItemRequest) => {
    return apiService.post<SageItem>(`/sage/items?companyId=${SAGE_COMPANY_ID}`, data);
  },

  update: async (id: number, data: UpdateSageItemRequest) => {
    return apiService.put<SageItem>(`/sage/items/${id}?companyId=${SAGE_COMPANY_ID}`, data);
  },

  delete: async (id: number) => {
    return apiService.delete<void>(`/sage/items/${id}?companyId=${SAGE_COMPANY_ID}`);
  },
};
